import { Injectable, Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, HostBinding, EventEmitter, Output, ViewChildren, ViewChild, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, combineLatest } from 'rxjs';
import { map, distinctUntilChanged, takeUntil, filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { trigger, state, style, AUTO_STYLE, transition, animate } from '@angular/animations';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';

function SidebarMenuComponent_ng_container_3_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 4);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("menuItem", item_r1)("level", 0);
} }
function SidebarMenuComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidebarMenuComponent_ng_container_3_li_1_Template, 1, 2, "li", 3);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.roleService.showItem$(item_r1.roles)));
} }
const _c0 = ["*"];
const _c1 = ["asm-menu-item", "", "menuItem", ""];
function ItemComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.menuItem.header);
} }
function ItemComponent_asm_menu_anchor_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "asm-menu-anchor", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("menuItem", ctx_r1.menuItem)("disable", ctx_r1.disable || ctx_r1.isItemDisabled);
} }
const _c2 = function (a0) { return { "asm-menu-anchor--open": a0 }; };
function ItemComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "asm-menu-anchor", 6);
    ɵngcc0.ɵɵlistener("clickAnchor", function ItemComponent_ng_container_3_Template_asm_menu_anchor_clickAnchor_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const _r3 = ɵngcc0.ɵɵreference(4); return _r3.onNodeToggleClick(); });
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "asm-menu-node", 8, 9);
    ɵngcc0.ɵɵlistener("isActive", function ItemComponent_ng_container_3_Template_asm_menu_node_isActive_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onNodeActive($event); })("isFiltered", function ItemComponent_ng_container_3_Template_asm_menu_node_isFiltered_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onNodeFiltered($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = ɵngcc0.ɵɵreference(4);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c2, _r3.isOpen))("menuItem", ctx_r2.menuItem)("isActive", _r3.isActiveChild);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(_r3.nodeService.toggleIconClasses);
    ɵngcc0.ɵɵproperty("@rotate", _r3.isOpen);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("menuItem", ctx_r2.menuItem)("level", ctx_r2.level)("disable", ctx_r2.disable || ctx_r2.isItemDisabled);
} }
function NodeComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵelementStart(1, "span", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.menuItem.label);
} }
function NodeComponent_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 5);
} if (rf & 2) {
    const childItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("menuItem", childItem_r2)("level", ctx_r3.level + 1)("disable", ctx_r3.disable);
} }
function NodeComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NodeComponent_ng_container_2_li_1_Template, 1, 3, "li", 4);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const childItem_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r1.roleService.showItem$(childItem_r2.roles)));
} }
const _c3 = ["rla"];
function AnchorComponent_a_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AnchorComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵlistener("click", function AnchorComponent_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clickAnchor.emit(); });
    ɵngcc0.ɵɵtemplate(1, AnchorComponent_a_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function AnchorComponent_a_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c4 = function (a0) { return { exact: a0 }; };
function AnchorComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 7, 8);
    ɵngcc0.ɵɵtemplate(2, AnchorComponent_a_2_ng_container_2_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r1.disable ? undefined : ctx_r1.menuItem.route)("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction1(3, _c4, ctx_r1.menuItem.linkActiveExact === undefined ? true : ctx_r1.menuItem.linkActiveExact));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function AnchorComponent_a_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AnchorComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵtemplate(1, AnchorComponent_a_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("href", ctx_r2.menuItem.url, ɵngcc0.ɵɵsanitizeUrl)("target", ctx_r2.menuItem.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function AnchorComponent_ng_template_4_i_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r11.menuItem.iconClasses || ctx_r11.anchorService.iconClasses);
} }
function AnchorComponent_ng_template_4_span_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const badge_r14 = ctx.$implicit;
    ɵngcc0.ɵɵclassMap(badge_r14.classes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(badge_r14.label);
} }
const _c5 = function (a0, a1) { return { "asm-badges": a0, "asm-toggle": a1 }; };
function AnchorComponent_ng_template_4_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtemplate(1, AnchorComponent_ng_template_4_span_3_span_1_Template, 2, 3, "span", 15);
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c5, ctx_r12.menuItem.badges, ctx_r12.menuItem.children));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r12.menuItem.badges);
} }
function AnchorComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AnchorComponent_ng_template_4_i_0_Template, 1, 2, "i", 10);
    ɵngcc0.ɵɵelementStart(1, "span", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, AnchorComponent_ng_template_4_span_3_Template, 4, 5, "span", 12);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.menuItem.iconClasses || ctx_r4.anchorService.iconClasses);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.menuItem.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.menuItem.badges || ctx_r4.menuItem.children);
} }
const _c6 = [[["", "toggleIcon", ""]]];
const _c7 = ["[toggleIcon]"];
var Modes;
(function (Modes) {
    Modes["EXPANDED"] = "expanded";
    Modes["EXPANDABLE"] = "expandable";
    Modes["MINI"] = "mini";
})(Modes || (Modes = {}));

class AnchorService {
}
AnchorService.ɵfac = function AnchorService_Factory(t) { return new (t || AnchorService)(); };
AnchorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AnchorService, factory: AnchorService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AnchorService, [{
        type: Injectable
    }], null, null); })();

class NodeService {
    constructor() {
        this.openedNode = new Subject();
    }
}
NodeService.ɵfac = function NodeService_Factory(t) { return new (t || NodeService)(); };
NodeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NodeService, factory: NodeService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NodeService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class RoleService {
    constructor() {
        this.role$ = new BehaviorSubject(undefined);
        this.unAuthorizedVisibility$ = new BehaviorSubject('hidden');
    }
    set role(role) {
        this.role$.next(role);
    }
    set unAuthorizedVisibility(visibility) {
        this.unAuthorizedVisibility$.next(visibility);
    }
    showItem$(roles) {
        return this.itemVisibilityBase$(roles).pipe(map((values) => values.isAuthorized || (!values.isAuthorized && values.unAuthorizedVisibility !== 'hidden')));
    }
    disableItem$(roles) {
        return this.itemVisibilityBase$(roles).pipe(map((values) => !values.isAuthorized && values.unAuthorizedVisibility === 'disabled'));
    }
    itemVisibilityBase$(roles) {
        return combineLatest([
            this.role$.pipe(map((role) => this.isAuthorized(role, roles))),
            this.unAuthorizedVisibility$,
        ]).pipe(map((value) => ({ isAuthorized: value[0], unAuthorizedVisibility: value[1] })));
    }
    isRole(role) {
        return typeof role === 'string' || typeof role === 'number';
    }
    isAuthorized(userRole, itemRoles) {
        if (!this.isRole(userRole) || !itemRoles || itemRoles.length === 0) {
            return true;
        }
        return itemRoles.includes(userRole);
    }
}
RoleService.ɵfac = function RoleService_Factory(t) { return new (t || RoleService)(); };
RoleService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RoleService, factory: RoleService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RoleService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class SearchService {
    constructor() {
        this._search = new Subject();
        this.search$ = this._search.asObservable();
    }
    set search(value) {
        this._search.next(value);
    }
    filter(search, label) {
        if (!search || !label) {
            return false;
        }
        return !label.toLowerCase().includes(search.toLowerCase());
    }
}
SearchService.ɵfac = function SearchService_Factory(t) { return new (t || SearchService)(); };
SearchService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SearchService, factory: SearchService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SearchService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const trackByItem = (index, item) => {
    return item.id || index;
};

class SidebarMenuComponent {
    constructor(anchorService, nodeService, searchService, roleService) {
        this.anchorService = anchorService;
        this.nodeService = nodeService;
        this.searchService = searchService;
        this.roleService = roleService;
        this.mode = Modes.EXPANDED;
        this.modes = Modes;
        this.disableAnimations = true;
        this.trackByItem = trackByItem;
    }
    set _menu(menu) {
        this.disableAnimations = true;
        this.menu = menu;
        setTimeout(() => {
            this.disableAnimations = false;
        });
    }
    set iconClasses(cssClasses) {
        this.anchorService.iconClasses = cssClasses;
    }
    set toggleIconClasses(cssClasses) {
        this.nodeService.toggleIconClasses = cssClasses;
    }
    set role(role) {
        this.roleService.role = role;
    }
    set unAuthorizedVisibility(visibility) {
        this.roleService.unAuthorizedVisibility = visibility;
    }
    set search(value) {
        this.searchService.search = value;
    }
}
SidebarMenuComponent.ɵfac = function SidebarMenuComponent_Factory(t) { return new (t || SidebarMenuComponent)(ɵngcc0.ɵɵdirectiveInject(AnchorService), ɵngcc0.ɵɵdirectiveInject(NodeService), ɵngcc0.ɵɵdirectiveInject(SearchService), ɵngcc0.ɵɵdirectiveInject(RoleService)); };
SidebarMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarMenuComponent, selectors: [["asm-angular-sidebar-menu"]], inputs: { mode: "mode", _menu: ["menu", "_menu"], iconClasses: "iconClasses", toggleIconClasses: "toggleIconClasses", role: "role", unAuthorizedVisibility: "unAuthorizedVisibility", search: "search" }, features: [ɵngcc0.ɵɵProvidersFeature([NodeService, AnchorService, RoleService, SearchService])], ngContentSelectors: _c0, decls: 4, vars: 4, consts: [[1, "asm-menu", 3, "ngClass"], [1, "asm-menu__node"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["asm-menu-item", "", "class", "asm-menu-item asm-menu-item--root", 3, "menuItem", "level", 4, "ngIf"], ["asm-menu-item", "", 1, "asm-menu-item", "asm-menu-item--root", 3, "menuItem", "level"]], template: function SidebarMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "ul", 1);
        ɵngcc0.ɵɵtemplate(3, SidebarMenuComponent_ng_container_3_Template, 3, 3, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", "asm-menu--mode-" + ctx.mode)("@.disabled", ctx.disableAnimations);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.menu)("ngForTrackBy", ctx.trackByItem);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ItemComponent]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{display:block;overflow:hidden}[_nghost-%COMP%]:hover{overflow:visible}[_nghost-%COMP%]     .asm-menu-item, [_nghost-%COMP%]     ul{margin:0;padding:0}[_nghost-%COMP%]     li{line-height:0}[_nghost-%COMP%]     .asm-menu-anchor__label, [_nghost-%COMP%]     .asm-menu-item__header, [_nghost-%COMP%]     .asm-menu-node__label{white-space:nowrap}[_nghost-%COMP%]     .asm-menu-node__label{display:none}[_nghost-%COMP%]     .asm-menu-node:not(.asm-menu-node--open)>.ng-trigger-openClose, [_nghost-%COMP%]     .asm-menu-node>.ng-trigger-openClose.ng-animating{overflow:hidden}[_nghost-%COMP%]     .asm-menu-item--filtered{display:none}[_nghost-%COMP%]     .asm-menu, [_nghost-%COMP%]     .asm-menu-node ul{list-style:none}[_nghost-%COMP%]     .asm-menu-anchor a{-webkit-user-select:none;align-items:center;cursor:pointer;display:flex;position:relative;text-decoration:none;user-select:none}[_nghost-%COMP%]     .asm-menu-item__header{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[_nghost-%COMP%]     .asm-menu-node .asm-menu-item__header{margin-left:-6px}[_nghost-%COMP%]     .asm-menu-anchor__icon{width:20px}[_nghost-%COMP%]     .asm-menu-anchor__pull.asm-badges, [_nghost-%COMP%]     .asm-menu-anchor__pull.asm-toggle{position:absolute;right:10px}[_nghost-%COMP%]     .asm-menu-anchor__pull.asm-badges .asm-badges__badge, [_nghost-%COMP%]     .asm-menu-anchor__pull.asm-badges .asm-toggle__icon, [_nghost-%COMP%]     .asm-menu-anchor__pull.asm-toggle .asm-badges__badge, [_nghost-%COMP%]     .asm-menu-anchor__pull.asm-toggle .asm-toggle__icon{float:right;margin-left:4px;text-align:center;white-space:nowrap}[_nghost-%COMP%]     .asm-menu-anchor__pull.asm-badges .asm-toggle__icon, [_nghost-%COMP%]     .asm-menu-anchor__pull.asm-toggle .asm-toggle__icon{margin:0 4px 0 8px}[_nghost-%COMP%]     .asm-menu--mode-expandable:not(:hover), [_nghost-%COMP%]     .asm-menu--mode-mini{width:50px}[_nghost-%COMP%]     .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__label, [_nghost-%COMP%]     .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__pull, [_nghost-%COMP%]     .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-item__header, [_nghost-%COMP%]     .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__label, [_nghost-%COMP%]     .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__pull, [_nghost-%COMP%]     .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-node>ul, [_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__label, [_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__pull, [_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-item__header, [_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__label, [_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__pull, [_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-node>ul{display:none}[_nghost-%COMP%]     .asm-menu--mode-mini .asm-menu-node__label{display:block}[_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item{position:relative}[_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item:hover>.asm-menu-anchor .asm-menu-anchor__label, [_nghost-%COMP%]     .asm-menu--mode-mini>ul>.asm-menu-item:hover>.asm-menu-node>ul{display:block!important;height:auto!important;left:100%;position:absolute;top:0;z-index:999}"], changeDetection: 0 });
SidebarMenuComponent.ctorParameters = () => [
    { type: AnchorService },
    { type: NodeService },
    { type: SearchService },
    { type: RoleService }
];
SidebarMenuComponent.propDecorators = {
    _menu: [{ type: Input, args: ['menu',] }],
    iconClasses: [{ type: Input }],
    toggleIconClasses: [{ type: Input }],
    role: [{ type: Input }],
    unAuthorizedVisibility: [{ type: Input }],
    search: [{ type: Input }],
    mode: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarMenuComponent, [{
        type: Component,
        args: [{
                selector: 'asm-angular-sidebar-menu',
                providers: [NodeService, AnchorService, RoleService, SearchService],
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: ` <div class="asm-menu" [ngClass]="'asm-menu--mode-' + mode" [@.disabled]="disableAnimations">
    <ng-content></ng-content>
    <ul class="asm-menu__node">
      <ng-container *ngFor="let item of menu; trackBy: trackByItem">
        <li
          asm-menu-item
          class="asm-menu-item asm-menu-item--root"
          *ngIf="roleService.showItem$(item.roles) | async"
          [menuItem]="item"
          [level]="0"
        ></li>
      </ng-container>
    </ul>
  </div>`,
                styles: [":host{display:block;overflow:hidden}:host:hover{overflow:visible}:host ::ng-deep .asm-menu-item,:host ::ng-deep ul{margin:0;padding:0}:host ::ng-deep li{line-height:0}:host ::ng-deep .asm-menu-anchor__label,:host ::ng-deep .asm-menu-item__header,:host ::ng-deep .asm-menu-node__label{white-space:nowrap}:host ::ng-deep .asm-menu-node__label{display:none}:host ::ng-deep .asm-menu-node:not(.asm-menu-node--open)>.ng-trigger-openClose,:host ::ng-deep .asm-menu-node>.ng-trigger-openClose.ng-animating{overflow:hidden}:host ::ng-deep .asm-menu-item--filtered{display:none}:host ::ng-deep .asm-menu,:host ::ng-deep .asm-menu-node ul{list-style:none}:host ::ng-deep .asm-menu-anchor a{-webkit-user-select:none;align-items:center;cursor:pointer;display:flex;position:relative;text-decoration:none;user-select:none}:host ::ng-deep .asm-menu-item__header{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::ng-deep .asm-menu-node .asm-menu-item__header{margin-left:-6px}:host ::ng-deep .asm-menu-anchor__icon{width:20px}:host ::ng-deep .asm-menu-anchor__pull.asm-badges,:host ::ng-deep .asm-menu-anchor__pull.asm-toggle{position:absolute;right:10px}:host ::ng-deep .asm-menu-anchor__pull.asm-badges .asm-badges__badge,:host ::ng-deep .asm-menu-anchor__pull.asm-badges .asm-toggle__icon,:host ::ng-deep .asm-menu-anchor__pull.asm-toggle .asm-badges__badge,:host ::ng-deep .asm-menu-anchor__pull.asm-toggle .asm-toggle__icon{float:right;margin-left:4px;text-align:center;white-space:nowrap}:host ::ng-deep .asm-menu-anchor__pull.asm-badges .asm-toggle__icon,:host ::ng-deep .asm-menu-anchor__pull.asm-toggle .asm-toggle__icon{margin:0 4px 0 8px}:host ::ng-deep .asm-menu--mode-expandable:not(:hover),:host ::ng-deep .asm-menu--mode-mini{width:50px}:host ::ng-deep .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__label,:host ::ng-deep .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__pull,:host ::ng-deep .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-item__header,:host ::ng-deep .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__label,:host ::ng-deep .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__pull,:host ::ng-deep .asm-menu--mode-expandable:not(:hover)>ul>.asm-menu-item>.asm-menu-node>ul,:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__label,:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-anchor .asm-menu-anchor__pull,:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-item__header,:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__label,:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-node>.asm-menu-anchor .asm-menu-anchor__pull,:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item>.asm-menu-node>ul{display:none}:host ::ng-deep .asm-menu--mode-mini .asm-menu-node__label{display:block}:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item{position:relative}:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item:hover>.asm-menu-anchor .asm-menu-anchor__label,:host ::ng-deep .asm-menu--mode-mini>ul>.asm-menu-item:hover>.asm-menu-node>ul{display:block!important;height:auto!important;left:100%;position:absolute;top:0;z-index:999}"]
            }]
    }], function () { return [{ type: AnchorService }, { type: NodeService }, { type: SearchService }, { type: RoleService }]; }, { mode: [{
            type: Input
        }], _menu: [{
            type: Input,
            args: ['menu']
        }], iconClasses: [{
            type: Input
        }], toggleIconClasses: [{
            type: Input
        }], role: [{
            type: Input
        }], unAuthorizedVisibility: [{
            type: Input
        }], search: [{
            type: Input
        }] }); })();

const TRANSITION_DURATION = 300;
const openCloseAnimation = trigger('openClose', [
    state('true', style({ height: AUTO_STYLE })),
    state('false', style({ height: 0 })),
    transition('false <=> true', animate(`${TRANSITION_DURATION}ms ease-in`)),
]);
const rotateAnimation = trigger('rotate', [
    state('true', style({ transform: 'rotate(-90deg)' })),
    transition('false <=> true', animate(`${TRANSITION_DURATION}ms ease-out`)),
]);

class ItemComponent {
    constructor(router, roleService, searchService, changeDetectorRef) {
        this.router = router;
        this.roleService = roleService;
        this.searchService = searchService;
        this.changeDetectorRef = changeDetectorRef;
        this.isRootNode = true;
        this.disable = false;
        this.onDestroy$ = new Subject();
        this.isActive = new BehaviorSubject(false);
        this.isFiltered = new BehaviorSubject(false);
        this.isActive$ = this.isActive.asObservable().pipe(distinctUntilChanged(), takeUntil(this.onDestroy$));
        this.isFiltered$ = this.isFiltered.asObservable().pipe(distinctUntilChanged(), takeUntil(this.onDestroy$));
        this.isItemFiltered = false;
        this.isItemDisabled = false;
    }
    get filtered() {
        return this.isItemFiltered;
    }
    get disabled() {
        return this.isItemDisabled || this.disable;
    }
    ngOnInit() {
        this.routerItemActiveSubscription();
        this.emitItemActive();
        this.menuSearchSubscription();
        this.disabledItemSubscription();
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    onNodeActive(event) {
        this.isActive.next(event);
    }
    onNodeFiltered(event) {
        this.isItemFiltered = event;
        this.isFiltered.next(event);
    }
    routerItemActiveSubscription() {
        this.router.events
            .pipe(filter((e) => e instanceof NavigationEnd), takeUntil(this.onDestroy$))
            .subscribe((e) => {
            this.emitItemActive();
        });
    }
    menuSearchSubscription() {
        if (!this.menuItem.children) {
            this.searchService.search$.pipe(takeUntil(this.onDestroy$)).subscribe((search) => {
                this.isItemFiltered = this.searchService.filter(search, this.menuItem.label || this.menuItem.header);
                this.isFiltered.next(this.isItemFiltered);
                this.changeDetectorRef.markForCheck();
            });
        }
    }
    disabledItemSubscription() {
        this.roleService
            .disableItem$(this.menuItem.roles)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((disabled) => (this.isItemDisabled = disabled));
    }
    emitItemActive() {
        if (this.menuItem.route) {
            this.isActive.next(this.isActiveRoute(this.menuItem.route));
        }
    }
    isActiveRoute(route) {
        return this.router.isActive(route, this.isItemLinkExact());
    }
    isItemLinkExact() {
        return this.menuItem.linkActiveExact === undefined ? true : this.menuItem.linkActiveExact;
    }
}
ItemComponent.ɵfac = function ItemComponent_Factory(t) { return new (t || ItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(RoleService), ɵngcc0.ɵɵdirectiveInject(SearchService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ItemComponent, selectors: [["li", "asm-menu-item", "", "menuItem", ""]], hostVars: 4, hostBindings: function ItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("asm-menu-item--filtered", ctx.filtered)("asm-menu-item--disabled", ctx.disabled);
    } }, inputs: { isRootNode: "isRootNode", disable: "disable", menuItem: "menuItem", level: "level" }, attrs: _c1, decls: 4, vars: 4, consts: [[3, "ngSwitch"], ["class", "asm-menu-item__header", 4, "ngSwitchCase"], ["class", "asm-menu-anchor", 3, "menuItem", "disable", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [1, "asm-menu-item__header"], [1, "asm-menu-anchor", 3, "menuItem", "disable"], [1, "asm-menu-anchor", 3, "ngClass", "menuItem", "isActive", "clickAnchor"], ["toggleIcon", ""], [1, "asm-menu-node", 3, "menuItem", "level", "disable", "isActive", "isFiltered"], ["node", ""]], template: function ItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, ItemComponent_span_1_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, ItemComponent_asm_menu_anchor_2_Template, 1, 2, "asm-menu-anchor", 2);
        ɵngcc0.ɵɵtemplate(3, ItemComponent_ng_container_3_Template, 5, 11, "ng-container", 3);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", !!ctx.menuItem.header);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", !ctx.menuItem.children && !ctx.menuItem.header);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", !!ctx.menuItem.children);
    } }, directives: function () { return [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, AnchorComponent, ɵngcc1.NgClass, NodeComponent]; }, encapsulation: 2, data: { animation: [rotateAnimation] }, changeDetection: 0 });
ItemComponent.ctorParameters = () => [
    { type: Router },
    { type: RoleService },
    { type: SearchService },
    { type: ChangeDetectorRef }
];
ItemComponent.propDecorators = {
    menuItem: [{ type: Input }],
    isRootNode: [{ type: Input }],
    level: [{ type: Input }],
    disable: [{ type: Input }],
    filtered: [{ type: HostBinding, args: ['class.asm-menu-item--filtered',] }],
    disabled: [{ type: HostBinding, args: ['class.asm-menu-item--disabled',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ItemComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'li[asm-menu-item][menuItem]',
                animations: [rotateAnimation],
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: `
    <ng-container [ngSwitch]="true">
      <span *ngSwitchCase="!!menuItem.header" class="asm-menu-item__header">{{ menuItem.header }}</span>
      <asm-menu-anchor
        *ngSwitchCase="!menuItem.children && !menuItem.header"
        class="asm-menu-anchor"
        [menuItem]="menuItem"
        [disable]="disable || isItemDisabled"
      ></asm-menu-anchor>
      <ng-container *ngSwitchCase="!!menuItem.children">
        <asm-menu-anchor
          class="asm-menu-anchor"
          [ngClass]="{ 'asm-menu-anchor--open': node.isOpen }"
          [menuItem]="menuItem"
          (clickAnchor)="node.onNodeToggleClick()"
          [isActive]="node.isActiveChild"
          ><i toggleIcon [@rotate]="node.isOpen" [class]="node.nodeService.toggleIconClasses"></i
        ></asm-menu-anchor>
        <asm-menu-node
          #node
          class="asm-menu-node"
          [menuItem]="menuItem"
          [level]="level"
          [disable]="disable || isItemDisabled"
          (isActive)="onNodeActive($event)"
          (isFiltered)="onNodeFiltered($event)"
        ></asm-menu-node>
      </ng-container>
    </ng-container>
  `
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: RoleService }, { type: SearchService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { isRootNode: [{
            type: Input
        }], disable: [{
            type: Input
        }], filtered: [{
            type: HostBinding,
            args: ['class.asm-menu-item--filtered']
        }], disabled: [{
            type: HostBinding,
            args: ['class.asm-menu-item--disabled']
        }], menuItem: [{
            type: Input
        }], level: [{
            type: Input
        }] }); })();

class NodeComponent {
    constructor(nodeService, roleService, changeDetectorRef) {
        this.nodeService = nodeService;
        this.roleService = roleService;
        this.changeDetectorRef = changeDetectorRef;
        this.disable = false;
        this.isActive = new EventEmitter();
        this.isFiltered = new EventEmitter();
        this.isOpen = false;
        this.isActiveChild = false;
        this.trackByItem = trackByItem;
        this.onDestroy$ = new Subject();
    }
    get open() {
        return this.isOpen;
    }
    ngAfterViewInit() {
        this.openedNodeSubscription();
        this.activeItemsSubscription();
        this.filterItemsSubscription();
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    onNodeToggleClick() {
        this.isOpen = !this.isOpen;
        this.nodeService.openedNode.next({ nodeComponent: this, nodeLevel: this.level });
        this.changeDetectorRef.markForCheck();
    }
    activeItemsSubscription() {
        const isChildrenItemsActive = this.menuItemComponents.map((item) => item.isActive$);
        if (isChildrenItemsActive && isChildrenItemsActive.length) {
            combineLatest(isChildrenItemsActive)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((itemsActiveState) => {
                this.isOpen = this.isActiveChild = itemsActiveState.includes(true);
                this.isActive.emit(this.isOpen);
            });
        }
    }
    filterItemsSubscription() {
        const isChildrenItemsFiltered = this.menuItemComponents.map((item) => item.isFiltered$);
        if (isChildrenItemsFiltered && isChildrenItemsFiltered.length) {
            combineLatest(isChildrenItemsFiltered)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((itemsFilteredState) => {
                const isItemsFiltered = itemsFilteredState.includes(false) === false;
                this.isFiltered.emit(isItemsFiltered);
            });
        }
    }
    openedNodeSubscription() {
        this.nodeService.openedNode
            .pipe(filter(() => !!this.isOpen), filter((node) => node.nodeComponent !== this), takeUntil(this.onDestroy$))
            .subscribe((node) => {
            if (node.nodeLevel <= this.level) {
                this.isOpen = false;
                this.changeDetectorRef.markForCheck();
            }
        });
    }
}
NodeComponent.ɵfac = function NodeComponent_Factory(t) { return new (t || NodeComponent)(ɵngcc0.ɵɵdirectiveInject(NodeService), ɵngcc0.ɵɵdirectiveInject(RoleService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NodeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NodeComponent, selectors: [["asm-menu-node"]], viewQuery: function NodeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(ItemComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuItemComponents = _t);
    } }, hostVars: 2, hostBindings: function NodeComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("asm-menu-node--open", ctx.open);
    } }, inputs: { disable: "disable", menuItem: "menuItem", level: "level" }, outputs: { isActive: "isActive", isFiltered: "isFiltered" }, decls: 3, vars: 4, consts: [["class", "asm-menu-item", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "asm-menu-item"], [1, "asm-menu-node__label"], ["asm-menu-item", "", "class", "asm-menu-item", 3, "menuItem", "level", "disable", 4, "ngIf"], ["asm-menu-item", "", 1, "asm-menu-item", 3, "menuItem", "level", "disable"]], template: function NodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul");
        ɵngcc0.ɵɵtemplate(1, NodeComponent_li_1_Template, 3, 1, "li", 0);
        ɵngcc0.ɵɵtemplate(2, NodeComponent_ng_container_2_Template, 3, 3, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@openClose", ctx.isOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.level === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.menuItem.children)("ngForTrackBy", ctx.trackByItem);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ItemComponent], pipes: [ɵngcc1.AsyncPipe], encapsulation: 2, data: { animation: [openCloseAnimation] }, changeDetection: 0 });
NodeComponent.ctorParameters = () => [
    { type: NodeService },
    { type: RoleService },
    { type: ChangeDetectorRef }
];
NodeComponent.propDecorators = {
    menuItem: [{ type: Input }],
    level: [{ type: Input }],
    disable: [{ type: Input }],
    isActive: [{ type: Output }],
    isFiltered: [{ type: Output }],
    open: [{ type: HostBinding, args: ['class.asm-menu-node--open',] }],
    menuItemComponents: [{ type: ViewChildren, args: [ItemComponent,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NodeComponent, [{
        type: Component,
        args: [{
                selector: 'asm-menu-node',
                animations: [openCloseAnimation],
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: `<ul [@openClose]="isOpen">
    <li *ngIf="level === 0" class="asm-menu-item">
      <span class="asm-menu-node__label">{{ menuItem.label }}</span>
    </li>
    <ng-container *ngFor="let childItem of menuItem.children; trackBy: trackByItem">
      <li
        asm-menu-item
        class="asm-menu-item"
        *ngIf="roleService.showItem$(childItem.roles) | async"
        [menuItem]="childItem"
        [level]="level + 1"
        [disable]="disable"
      ></li>
    </ng-container>
  </ul>`
            }]
    }], function () { return [{ type: NodeService }, { type: RoleService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { disable: [{
            type: Input
        }], isActive: [{
            type: Output
        }], isFiltered: [{
            type: Output
        }], open: [{
            type: HostBinding,
            args: ['class.asm-menu-node--open']
        }], menuItem: [{
            type: Input
        }], level: [{
            type: Input
        }], menuItemComponents: [{
            type: ViewChildren,
            args: [ItemComponent]
        }] }); })();

class AnchorComponent {
    constructor(anchorService) {
        this.anchorService = anchorService;
        this.disable = false;
        this.clickAnchor = new EventEmitter();
    }
    get active() {
        var _a;
        return this.isActive || (!!((_a = this.routerLinActive) === null || _a === void 0 ? void 0 : _a.isActive) && !this.disable);
    }
}
AnchorComponent.ɵfac = function AnchorComponent_Factory(t) { return new (t || AnchorComponent)(ɵngcc0.ɵɵdirectiveInject(AnchorService)); };
AnchorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AnchorComponent, selectors: [["asm-menu-anchor"]], viewQuery: function AnchorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.routerLinActive = _t.first);
    } }, hostVars: 2, hostBindings: function AnchorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("asm-menu-anchor--active", ctx.active);
    } }, inputs: { disable: "disable", menuItem: "menuItem", isActive: "isActive" }, outputs: { clickAnchor: "clickAnchor" }, ngContentSelectors: _c7, decls: 6, vars: 4, consts: [[3, "ngSwitch"], [3, "click", 4, "ngSwitchCase"], ["routerLinkActive", "", 3, "routerLink", "routerLinkActiveOptions", 4, "ngSwitchCase"], [3, "href", "target", 4, "ngSwitchCase"], ["innerItem", ""], [3, "click"], [4, "ngTemplateOutlet"], ["routerLinkActive", "", 3, "routerLink", "routerLinkActiveOptions"], ["rla", "routerLinkActive"], [3, "href", "target"], ["class", "asm-menu-anchor__icon", 3, "class", 4, "ngIf"], [1, "asm-menu-anchor__label"], ["class", "asm-menu-anchor__pull", 3, "ngClass", 4, "ngIf"], [1, "asm-menu-anchor__icon"], [1, "asm-menu-anchor__pull", 3, "ngClass"], ["class", "asm-badges__badge", 3, "class", 4, "ngFor", "ngForOf"], [1, "asm-toggle__icon"], [1, "asm-badges__badge"]], template: function AnchorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, AnchorComponent_a_1_Template, 2, 1, "a", 1);
        ɵngcc0.ɵɵtemplate(2, AnchorComponent_a_2_Template, 3, 5, "a", 2);
        ɵngcc0.ɵɵtemplate(3, AnchorComponent_a_3_Template, 2, 3, "a", 3);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(4, AnchorComponent_ng_template_4_Template, 4, 3, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", !!ctx.menuItem.children);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", !!ctx.menuItem.route || ctx.menuItem.route === "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", !!ctx.menuItem.url);
    } }, directives: [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgTemplateOutlet, ɵngcc2.RouterLinkWithHref, ɵngcc2.RouterLinkActive, ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf], encapsulation: 2, changeDetection: 0 });
AnchorComponent.ctorParameters = () => [
    { type: AnchorService }
];
AnchorComponent.propDecorators = {
    menuItem: [{ type: Input }],
    isActive: [{ type: Input }],
    disable: [{ type: Input }],
    clickAnchor: [{ type: Output }],
    active: [{ type: HostBinding, args: ['class.asm-menu-anchor--active',] }],
    routerLinActive: [{ type: ViewChild, args: ['rla',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AnchorComponent, [{
        type: Component,
        args: [{
                selector: 'asm-menu-anchor',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: `<ng-container [ngSwitch]="true">
      <a *ngSwitchCase="!!menuItem.children" (click)="clickAnchor.emit()">
        <ng-container *ngTemplateOutlet="innerItem"></ng-container>
      </a>
      <a
        *ngSwitchCase="!!menuItem.route || menuItem.route === ''"
        [routerLink]="disable ? undefined : menuItem.route"
        routerLinkActive
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: menuItem.linkActiveExact === undefined ? true : menuItem.linkActiveExact }"
      >
        <ng-container *ngTemplateOutlet="innerItem"></ng-container>
      </a>
      <a *ngSwitchCase="!!menuItem.url" [href]="menuItem.url" [target]="menuItem.target">
        <ng-container *ngTemplateOutlet="innerItem"></ng-container>
      </a>
    </ng-container>

    <ng-template #innerItem>
      <i
        *ngIf="menuItem.iconClasses || anchorService.iconClasses"
        [class]="menuItem.iconClasses || anchorService.iconClasses"
        class="asm-menu-anchor__icon"
      ></i>
      <span class="asm-menu-anchor__label">{{ menuItem.label }}</span>
      <span
        *ngIf="menuItem.badges || menuItem.children"
        class="asm-menu-anchor__pull"
        [ngClass]="{ 'asm-badges': menuItem.badges, 'asm-toggle': menuItem.children }"
      >
        <span *ngFor="let badge of menuItem.badges" [class]="badge.classes" class="asm-badges__badge">{{
          badge.label
        }}</span>
        <span class="asm-toggle__icon"><ng-content select="[toggleIcon]"></ng-content></span>
      </span>
    </ng-template>`
            }]
    }], function () { return [{ type: AnchorService }]; }, { disable: [{
            type: Input
        }], clickAnchor: [{
            type: Output
        }], active: [{
            type: HostBinding,
            args: ['class.asm-menu-anchor--active']
        }], menuItem: [{
            type: Input
        }], isActive: [{
            type: Input
        }], routerLinActive: [{
            type: ViewChild,
            args: ['rla']
        }] }); })();

class SidebarMenuModule {
}
SidebarMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SidebarMenuModule });
SidebarMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SidebarMenuModule_Factory(t) { return new (t || SidebarMenuModule)(); }, imports: [[RouterModule, CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SidebarMenuModule, { declarations: function () { return [SidebarMenuComponent, ItemComponent, NodeComponent, AnchorComponent]; }, imports: function () { return [RouterModule, CommonModule]; }, exports: function () { return [SidebarMenuComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarMenuModule, [{
        type: NgModule,
        args: [{
                declarations: [SidebarMenuComponent, ItemComponent, NodeComponent, AnchorComponent],
                imports: [RouterModule, CommonModule],
                exports: [SidebarMenuComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of angular-sidebar-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Modes, SidebarMenuComponent, SidebarMenuModule, NodeService as ɵa, AnchorService as ɵb, RoleService as ɵc, SearchService as ɵd, ItemComponent as ɵe, openCloseAnimation as ɵf, rotateAnimation as ɵg, NodeComponent as ɵh, AnchorComponent as ɵi };

//# sourceMappingURL=angular-sidebar-menu.js.map